import React from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { ProvisionPanel } from "../components/provision-panel.jsx";
import type { AdminClient, AdminOutletContext } from "../lib/outlet-context";

export function ClientNewPage() {
  const { clients, addClient, api } = useOutletContext<AdminOutletContext>();
  const navigate = useNavigate();

  const handleClientCreated = (client: AdminClient) => {
    addClient(client);
    navigate(`/clients/${client.id}`);
  };

  return (
    <ProvisionPanel
      clients={clients}
      api={api}
      onClientCreated={handleClientCreated}
    />
  );
}
